import {
  DropDown,
  SearchBar,
  NewSiteButton,
  Card,
} from "../components/textField";
import TopNav from "../components/topnav";
import { useState, useEffect, useMemo } from "react";
import { content } from "../utils/data";
import EnhancedTable from "../components/newTable";
import SiteTabs from "../components/tabs";
import {
  getDocumentsRejected,
  getDocumentsApproved,
  getDocumentsPending,
  approvedRejected,
  getStatesDropDown,
  getSiteDropDown,
  getLocationDropDown,
  getBorrowals,
  generateTranslation,
  getTranslationStatus,
  decideTranslation,
  generateSummary,
  getSummaryStatus,
  decideSummary,
  getSummary,
} from "../api/serverApi";
import SummaryModal from "../components/approvalSummaryModal";
import TranslationModal from "../components/approvalTranslationModal";
import Approve from "../assests/approve.png";
import Reject from "../assests/reject.png";
import Modal from "../components/modal";
import DocumentModal from "../components/documentModal";
import Spinner from "../components/spinner";
import { Button } from "@mui/material";
import StatusModal from "../components/statusModal";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import { useCookies } from "react-cookie";
import * as microsoftTeams from "@microsoft/teams-js";

const Approval = () => {

  const [open, setOpen] = useState(false);
  const [rejected, getRejeceted] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [approved, getApproved] = useState([]);
  const [pending, getPending] = useState([]);
  const [pendingRows, setPendingRows] = useState(pending || []);
  const [showModal, setShowModal] = useState(false);
  const [selectedApprovalId, setSelectedApprovalId] = useState(null);
  const [reason, setReason] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedSiteId, setSelecteSiteId] = useState("");
  const [borrowal, setBorrowal] = useState([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { instance, accounts } = useMsal();
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
const [translationOpen, setTranslationOpen] = useState(false);

const [translationLoading, setTranslationLoading] = useState(false);

const [translationCompleted, setTranslationCompleted] = useState(false);

const [selectedDocumentId, setSelectedDocumentId] = useState(null);

const [translationResponse, setTranslationResponse] = useState(null);
const [translationPreviewUrl, setTranslationPreviewUrl] = useState("");

const [summaryOpen, setSummaryOpen] = useState(false);
const [summaryLoading, setSummaryLoading] = useState(false);
const [summaryCompleted, setSummaryCompleted] = useState(false);
const [summaryResponse, setSummaryResponse] = useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchRejectedDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsRejected(token);
        getRejeceted(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedDocuments();
  }, []);

  useEffect(() => {
    const fetchApprovedDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsApproved(token);
        getApproved(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedDocuments();
  }, []);

  useEffect(() => {
    const fetchPendingDocuments = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getDocumentsPending(token);
        console.log("Pending Documents:", response.data);
        getPending(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingDocuments();

  }, []);

  useEffect(() => {
    const fetchBorrowals = async () => {
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getBorrowals(token);

        setBorrowal(response.data);
      } catch (error) {
        const message =
          error.response?.data?.detail || "An unexpected error occurred";
        setResponseMessage(message);
        setisModalOpen(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBorrowals();
  }, []);

  const rowsRejected = useMemo(() => {
    return (rejected || [])
      .filter(({ document_name, state_name, location_name, site_name }) =>
        [document_name, state_name, location_name, site_name].some((field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        ),
      )
      .map(
        ({
          approval_id,
          sharepoint_id,
          document_name,
          approved_rejected_at,
          state_name,
          location_name,
          site_name,
          document_type,
          document_copy_type,
          document_category,
          os_number,
          box_number,
          start_year,
          end_year,
          valid_until,
          saledeed_no,
          seller_name,
          receipt_number,
          khata,
          amount,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          url,
          loction_id,
          lease_deed_date,
          lease_no,
          purchase_date,
        }) => {
          const formattedDate = approved_rejected_at
            ? new Date(approved_rejected_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            approved_rejected_at: formattedDate,
            state_name,
            sharepoint_id,
            location_name,
            start_year,
            end_year,
            valid_until,
            saledeed_no,
            seller_name,
            receipt_number,
            khata,
            amount,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            site_id,
            state_id,
            loction_id,
            site_name,
            url,
            lease_deed_date,
            lease_no,
            purchase_date,
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    start_year,
                    end_year,
                    valid_until,
                    saledeed_no,
                    seller_name,
                    receipt_number,
                    khata,
                    amount,
                    other_document_title,
                    other_document_description,
                    reference_document_title,
                    reference_document_description,

                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,

                    parent_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    os_number,
                    url,
                    box_number,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    building_code,
                    entity_name,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
          };
        },
      );
  }, [rejected, searchTerm]);

  const filteredRowsRejected = rowsRejected.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsApproved = useMemo(() => {
    return (approved || [])
      .filter(({ document_name, state_name, location_name, site_name }) =>
        [document_name, state_name, location_name, site_name].some((field) =>
          String(field || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
        ),
      )
      .map(
        ({
          approval_id,
          sharepoint_id,
          document_name,
          loction_id,
          state_id,
          site_id,
          approved_rejected_at,
          state_name,
          location_name,
          site_name,
          cnr_number,  
          document_type,
          document_copy_type,
          document_category,
          building_code,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          os_number,
          box_number,
          url,
          unique_survey_no,
          entity_name,
          lease_deed_date,
          lease_no,
          uploaded_by,
          purchase_date,
        }) => {
          const formattedDate = approved_rejected_at
            ? new Date(approved_rejected_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            sharepoint_id,
            approved_rejected_at: formattedDate,
            state_name,
            location_name,
            loction_id,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,

            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            state_id,
            site_id,
            site_name,
            url,
            lease_deed_date,
            lease_no,
            purchase_date,
              uploaded_by,
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    cnr_number, 
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    start_year,
                    end_year,
                    valid_until,
                    receipt_number,
                    khata,
                    amount,
                    saledeed_no,
                    seller_name,
                    other_document_title,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,

                    parent_document_description,
                    reference_document_title,
                    reference_document_description,
                    other_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    os_number,
                    box_number,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    url,
                    building_code,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                    entity_name,
                      uploaded_by,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
          };
        },
      );
  }, [approved, searchTerm]);

  const filteredRowsApproved = rowsApproved.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsPending = useMemo(() => {
    return (pending || [])
      .filter(
        ({
          document_name,
          state_name,
          location_name,
          site_name,
          document_type,
          document_copy_type,
          document_category,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,

          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
cnr_number,
          parent_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          uploaded_by
        }) =>
          [
            document_name,
            state_name,
            location_name,
            site_name,
            document_type,
            document_copy_type,
            document_category,
            os_number,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,
cnr_number,
            parent_document_description,
            box_number,
            unique_survey_no,
            building_code,
            entity_name,
            uploaded_by
          ].some((field) =>
            String(field || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()),
          ),
      )
      .map(
        ({
          approval_id,
            document_id,
          state_name,
          location_name,
          sharepoint_id,
          site_name,
          document_name,
          uploaded_at,
          document_type,
          loction_id,
          state_id,
          site_id,
          document_copy_type,
          document_category,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,
cnr_number,
          parent_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          os_number,
          box_number,
          url,
          unique_survey_no,
          building_code,
          lease_deed_date,
          lease_no,
          purchase_date,
          entity_name,
          uploaded_by
        }) => {
          const formattedDate = uploaded_at
            ? new Date(uploaded_at)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
            key: approval_id,
            loction_id,
            state_id,
            site_id,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            url,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,
cnr_number,

            parent_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            lease_deed_date,
            lease_no,
            purchase_date,
            uploaded_by,
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMetadata({
                    approval_id,
                    sharepoint_id,
                    document_name,
                    approved_rejected_at: formattedDate,
                    state_name,
                    location_name,
                    start_year,
                    end_year,
                    valid_until,
                    receipt_number,
                    khata,
                    amount,
                    saledeed_no,
                    seller_name,
                    other_document_title,
                    other_document_description,
                    reference_document_title,
                    reference_document_description,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,
cnr_number,
                    parent_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    site_name,
                    document_type,
                    document_copy_type,
                    document_category,
                    os_number,
                    box_number,
                   
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    building_code,
                    url,
                    lease_deed_date,
                    lease_no,
                    purchase_date,
                    entity_name,
                  });
                  setModalOpen(true);
                }}
              >
                {document_name}
              </a>
            ),
            uploaded_at: formattedDate,
            state_name,
            location_name,
            site_name,
            sharepoint_id,
            actions: (
         <div className="flex">

  {/* Translate */}
  {/* <Button
    variant="contained"
    size="small"
    sx={{
      backgroundColor: "#1976d2",
      color: "black",
      ml: 1,
      textTransform: "none",
      borderRadius: "15px",
      minWidth: "60px",
      height: "30px",
      boxShadow: "none",
    }}
    onClick={() => handleTranslate(document_id)}
  >
    Translate
  </Button> */}

  {/* Summary */}
  {/* <Button
    variant="contained"
    size="small"
    sx={{
      backgroundColor: "#FFA500",
      color: "black",
      ml: 1,
      textTransform: "none",
      borderRadius: "15px",
      minWidth: "60px",
      height: "30px",
      boxShadow: "none",
    }}
    onClick={() => handleSummary(document_id)}
  >
    Summary
  </Button> */}

  {/* Approve */}
  <img
    src={Approve}
    alt="Approve"
    style={{
      width: "80px",
      height: "30px",
      cursor: "pointer",
      marginRight: "10px",
      marginLeft: "10px",
    }}
    onClick={() => handleApprove(approval_id)}
  />

  {/* Reject */}
  <img
    src={Reject}
    alt="Reject"
    style={{
      width: "70px",
      height: "30px",
      cursor: "pointer",
      marginRight: "10px",
    }}
    onClick={() => {
      setSelectedApprovalId(approval_id);
      setShowModal(true);
    }}
  />

</div>
            ),
          };
        },
      );
  }, [pending, searchTerm]);

  const filteredRowsPending = rowsPending.filter((row) => {
    const matchState = selectedStateId
      ? row.state_id === selectedStateId
      : true;
    const matchLocation = selectedLocationId
      ? row.loction_id === selectedLocationId
      : true;
    const matchSite = selectedSiteId ? row.site_id === selectedSiteId : true;
    return matchState && matchLocation && matchSite;
  });

  const rowsBorrowed = useMemo(() => {
    return (borrowal || [])
      .filter(
        ({
          document_name,
          status,
          borrowal_date,
          borrowed_user,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          other_document_title,
          other_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          location_id,
          site_name,
          state_name,
          location_name,
          document_type,
          document_copy_type,
          document_category,
        }) =>
          [document_name, status, borrowal_date, borrowed_user].some((field) =>
            String(field || "")
              .toLowerCase()
              .includes(searchTerm.toLowerCase()),
          ),
      )
      .map(
        ({
          document_name,
          status,
          borrowal_date,
          borrowed_user,
          start_year,
          end_year,
          valid_until,
          receipt_number,
          khata,
          amount,
          saledeed_no,
          seller_name,
          other_document_title,
          other_document_description,
          reference_document_title,
          reference_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          parent_document_title,

          parent_document_description,
          os_number,
          box_number,
          unique_survey_no,
          building_code,
          entity_name,
          site_id,
          state_id,
          location_id,
          site_name,
          state_name,
          location_name,
          document_type,
          document_copy_type,
          document_category,
        }) => {
          const formattedDate = borrowal_date
            ? new Date(borrowal_date)
                .toLocaleDateString("en-GB")
                .replace(/\//g, "-")
            : "";

          return {
      
            document_name,
            status,
            borrowal_date: formattedDate,
            borrowed_user,
            start_year,
            end_year,
            valid_until,
            receipt_number,
            khata,
            amount,
            saledeed_no,
            seller_name,
            other_document_title,
            other_document_description,
            reference_document_title,
            reference_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            parent_document_title,

            parent_document_description,
            os_number,
            box_number,
            unique_survey_no,
            building_code,
            entity_name,
            site_id,
            state_id,
            location_id,
            site_name,
            state_name,
            location_name,
            document_type,
            document_copy_type,
            document_category,
          };
        },
      );
  }, [borrowal, searchTerm]);

  const handleApprove = async (approval_id) => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      const data = {
        approval_id,
        decision: "Approved",
      };

      await approvedRejected(approval_id, data, token);

      const [pendingRes, approvedRes, rejectedRes] = await Promise.all([
        getDocumentsPending(token),
        getDocumentsApproved(token),
        getDocumentsRejected(token),
      ]);

      getPending(pendingRes.data);
      getApproved(approvedRes.data);
      getRejeceted(rejectedRes.data);

      setResponseMessage("Document approved successfully.");
      setIsSuccess(true);
      setisModalOpen(true);
    } catch (error) {
      console.error("Approve failed:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      setisModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleRejectConfirm = async () => {
    setLoading(true);

    const data = {
      approval: selectedApprovalId,
      decision: "Rejected",
      reason: reason,
    };

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }

      await approvedRejected(selectedApprovalId, data, token);

      const [pendingRes, approvedRes, rejectedRes] = await Promise.all([
        getDocumentsPending(token),
        getDocumentsApproved(token),
        getDocumentsRejected(token),
      ]);

      getPending(pendingRes.data);
      getApproved(approvedRes.data);
      getRejeceted(rejectedRes.data);

      setResponseMessage("Document rejected successfully.");
      setIsSuccess(true);
      setisModalOpen(true);

      setShowModal(false);
      setSelectedApprovalId(null);
      setOpen(false);
      resetForm();
    } catch (error) {
      console.error("Reject API error:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(details || "An unexpected error occurred");
      }

      setIsSuccess(false);
      setisModalOpen(true);
      setShowModal(false);
      setSelectedApprovalId(null);
      setOpen(false);
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setReason("");
  };



const handleTranslate = (documentId) => {
  setSelectedDocumentId(documentId);

  setTranslationCompleted(false);
  setTranslationLoading(false);
  setTranslationResponse(null);
  setTranslationPreviewUrl("");

  setTranslationOpen(true);
};
const handleSummary = (documentId) => {
  setSelectedDocumentId(documentId);

  setSummaryCompleted(false);
  setSummaryLoading(false);
  setSummaryResponse(null);

  setSummaryOpen(true);
}





const handleGenerateTranslation = async () => {
  try {
    setTranslationLoading(true);
    setTranslationCompleted(false);
    setTranslationResponse(null);

   

    // Get access token
    let token;

    if (isInTeams()) {
      token = await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: resolve,
          failureCallback: reject,
          resources: ["https://graph.microsoft.com"],
        });
      });
    } else {
      token = await getValidAccessToken(instance, accounts);
    }

    // STEP 1 - Start translation job
    const startResponse = await generateTranslation(
      selectedDocumentId,
    
      token
    );

    console.log(
      "Translation Generate Response:",
      startResponse.data
    );

    const jobId = startResponse.data?.job_id;

    if (!jobId) {
      throw new Error(
        "Translation job ID was not returned by the server."
      );
    }

    console.log("Translation Job ID:", jobId);

    // STEP 2 - Poll status
    const maxAttempts = 225;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {

      // Wait 4 seconds before checking
      await new Promise((resolve) =>
        setTimeout(resolve, 4000)
      );

      const statusResponse = await getTranslationStatus(
        selectedDocumentId,
        jobId,
        token
      );

      const result = statusResponse.data;

      console.log(
        `Translation Status - Attempt ${attempt + 1}:`,
        result
      );

      // Still processing
      if (result.status === "processing") {
        continue;
      }

      // Failed
      if (result.status === "failed") {
        throw new Error(
          result.error || "Translation failed."
        );
      }

      // Completed
   if (result.status === "done") {
  console.log(
    "Translation Completed:",
    result
  );

  setTranslationResponse(result);

  // Store the PDF URL immediately
  setTranslationPreviewUrl(result?.download_url || "");

  setTranslationCompleted(true);
  setTranslationLoading(false);

  return;
}
      // Unknown status
      throw new Error(
        `Unknown translation status: ${result.status}`
      );
    }

    // Maximum polling time reached
    throw new Error(
      "This is taking longer than expected. Please try again."
    );

  } catch (error) {
    console.error(
      "Translation generation failed:",
      error
    );

    setTranslationLoading(false);
    setTranslationCompleted(false);

    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error?.message ||
      "Translation failed. Please try again.";

    setResponseMessage(message);
    setIsSuccess(false);
    setisModalOpen(true);
  }
};

const handleGenerateSummary = async () => {
  try {
    setSummaryLoading(true);
    setSummaryCompleted(false);
    setSummaryResponse(null);

    console.log("Summary Document ID:", selectedDocumentId);

    let token;

    if (isInTeams()) {
      token = await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: resolve,
          failureCallback: reject,
          resources: ["https://graph.microsoft.com"],
        });
      });
    } else {
      token = await getValidAccessToken(instance, accounts);
    }

    // STEP 1 - Start summary job
    const startResponse = await generateSummary(
      selectedDocumentId,
      token
    );

    console.log(
      "Summary Generate Response:",
      startResponse.data
    );

    const jobId = startResponse.data?.job_id;

    if (!jobId) {
      throw new Error(
        "Summary job ID was not returned by the server."
      );
    }

    console.log("Summary Job ID:", jobId);

    // STEP 2 - Poll status
    const maxAttempts = 225;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      await new Promise((resolve) =>
        setTimeout(resolve, 4000)
      );

      const statusResponse = await getSummaryStatus(
        selectedDocumentId,
        jobId,
        token
      );

      const result = statusResponse.data;

      console.log(
        `Summary Status - Attempt ${attempt + 1}:`,
        result
      );

      if (result.status === "processing") {
        continue;
      }

      if (result.status === "failed") {
        throw new Error(
          result.error || "Summary generation failed."
        );
      }

      if (result.status === "done") {
        console.log(
          "Summary Completed:",
          result
        );

        setSummaryResponse(result);
        setSummaryCompleted(true);
        setSummaryLoading(false);

        return;
      }

      throw new Error(
        `Unknown summary status: ${result.status}`
      );
    }

    throw new Error(
      "This is taking longer than expected. Please try again."
    );

  } catch (error) {
    console.error(
      "Summary generation failed:",
      error
    );

    setSummaryLoading(false);
    setSummaryCompleted(false);

    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error?.message ||
      "Summary generation failed. Please try again.";

    setResponseMessage(message);
    setIsSuccess(false);
    setisModalOpen(true);
  }
};

const handlePreviewTranslation = () => {
  console.log(
    "FULL TRANSLATION RESPONSE:",
    translationResponse
  );

  const previewUrl = translationResponse?.download_url;

  console.log(
    "TRANSLATION DOWNLOAD URL:",
    previewUrl
  );

  if (!previewUrl) {
    console.error("Translation download URL is missing");
    return;
  }

  setTranslationPreviewUrl(previewUrl);
};


const handleDecision = async (type, decision) => {
  try {
    let token;

    if (isInTeams()) {
      token = await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: resolve,
          failureCallback: reject,
          resources: ["https://graph.microsoft.com"],
        });
      });
    } else {
      token = await getValidAccessToken(instance, accounts);
    }

    const isTranslation = type === "translation";
    const responseData = isTranslation
      ? translationResponse
      : summaryResponse;

    const decideApi = isTranslation
      ? decideTranslation
      : decideSummary;

    const data = {
      decision,
      ...(decision === "Accept" && {
        download_url: responseData?.download_url,
      }),
    };

    console.log(`${type} ${decision} Data:`, data);

    const response = await decideApi(
      selectedDocumentId,
      data,
      token
    );

    console.log(`${type} ${decision} Response:`, response.data);

    setResponseMessage(
      response.data?.message ||
        `${type === "translation" ? "Translation" : "Summary"} ${
          decision === "Accept" ? "accepted" : "rejected"
        } successfully.`
    );

    setIsSuccess(true);
    setisModalOpen(true);

    if (isTranslation) {
      setTranslationOpen(false);
      setTranslationCompleted(false);
      setTranslationResponse(null);
      setTranslationPreviewUrl("");
    } else {
      setSummaryOpen(false);
      setSummaryCompleted(false);
      setSummaryResponse(null);
    }
  } catch (error) {
    console.error(`${type} ${decision} failed:`, error);

    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error?.message ||
      `Failed to ${decision.toLowerCase()} ${type}.`;

    setResponseMessage(message);
    setIsSuccess(false);
    setisModalOpen(true);
  }
};const handleAcceptTranslation = () =>
  handleDecision("translation", "Accept");

const handleRejectTranslation = () =>
  handleDecision("translation", "Reject");

const handleAcceptSummary = () =>
  handleDecision("summary", "Accept");

const handleRejectSummary = () =>
  handleDecision("summary", "Reject");


  // states start 
useEffect(() => {
  // setLoading(true);
  getStatesDropDown(cookies.accessToken)
    .then((response) => {
      // Handle successful response
      setGetState(response.data);
      console.log(response);

      setSelectedLocationId("");
      setSelecteSiteId("");

      // setLoading(false);
    })
    .catch((error) => {
      // Handle error
      // setshowModal(true);
      // setModalTitle("Something went wrong, Please try again");
      console.error("Error:", error);

      // setLoading(false);
    });
}, []);

// states end 
// location start

 useEffect(() => {
  if (selectedStateId) {
    getLocationDropDown(
      { state_id: selectedStateId },
      cookies.accessToken
    )
      .then((response) => {
        setGetLocation(response.data);
        console.log(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    setGetLocation([]);
    setSelectedLocationId("");
    setSelecteSiteId("");
  }
}, [selectedStateId]);
// location end
useEffect(() => {
  if (selectedLocationId) {
    getSiteDropDown(
      { location_id: selectedLocationId },
      cookies.accessToken
    )
      .then((response) => {
        setGetSite(response.data);
        console.log(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    setGetSite([]);
    setSelecteSiteId("");
  }
}, [selectedLocationId]);
  return (
    <>
      <div>
        <TopNav />
      </div>
      <div>
        
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl">Approval</div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="State"
            placeholder="None"
            responseData={getState}
            labelKey="name"
            valueKey="state_id"
            onChange={(e) => setSelectedStateId(Number(e.target.value))}
            value={selectedStateId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Location"
            placeholder="None"
            responseData={getLocation}
            labelKey="name"
            valueKey="location_id"
            onChange={(e) => setSelectedLocationId(Number(e.target.value))}
            value={selectedLocationId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Site"
            placeholder="None"
            responseData={getSite}
            labelKey="name"
            valueKey="site_id"
            onChange={(e) => setSelecteSiteId(Number(e.target.value))}
            value={selectedSiteId}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setSelectedStateId(null);
              setSelectedLocationId(null);
              setSelecteSiteId(null);
              setSearchTerm("");
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "10px",
              whiteSpace: "nowrap", // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>
      </div>
      <div className="py-2">
        <SiteTabs
          Pending={
            <>
              <EnhancedTable
                rows={filteredRowsPending}
                header={content.pending}
                height="375px"
              />
              <Modal
                open={showModal}
                onClose={() => setShowModal(false)}
                label="Are you sure you want to reject?"
                subheading="Reason For Rejection*"
                showTextBox={true}
                reason={reason}
                setReason={setReason}
                primaryButton={
                  <button
                    onClick={handleRejectConfirm}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Reject
                  </button>
                }
                secondaryButton={
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      backgroundColor: "gray",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                }
              />
            </>
          }
          Approval={
            <EnhancedTable
              rows={filteredRowsApproved}
              header={content.approved}
              height="375px"
            />
          }
          Rejected={
            <EnhancedTable
              rows={filteredRowsRejected}
              header={content.rejected}
              height="375px"
            />
          }
          Borrowal={
            <EnhancedTable
              rows={rowsBorrowed}
              header={content.borrowed}
              height="375px"
            />
          }
        />
        <DocumentModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          metadata={selectedMetadata}
          metadataFields={[
            { key: "document_name", label: "File Name" },
            { key: "state_name", label: "State" },
            { key: "location_name", label: "Location" },
            { key: "site_name", label: "Site" },
            { key: "uploaded_at", label: "Upload Date" },
            { key: "box_number", label: "Box No" },
            { key: "unique_survey_no", label: "Survey No" },
            { key: "os_number", label: "OS Number" },
            { key: "cnr_number", label: "CNR Number" },
            { key: "document_category", label: "Document Category" },
            { key: "document_copy_type", label: "Document Classification" },
            { key: "entity_name", label: "Entity" },
            { key: "building_name", label: "Building Name" },
            { key: "saledeed_no", label: "Sale Deed No" },
            { key: "seller_name", label: "Seller Name" },
            { key: "purchase_date", label: "Purchase Date" },
            { key: "lease_deed_date", label: "Lease Deed Date" },
            { key: "lease_no", label: "Lease No" },
            { key: "start_year", label: "Start Year" },
            { key: "end_year", label: "End Year" },
            { key: "valid_until", label: "Valid Until" },
            { key: "receipt_number", label: "Receipt Number" },
            { key: "khata", label: "Khata" },
            { key: "amount", label: "Amount(Rs.)" },
            { key: "other_document_title", label: "Other Document Title" },
            {
              key: "other_document_description",
              label: "Other Document Description",
            },
            {
              key: "reference_document_title",
              label: "Reference Document Title",
            },
            {
              key: "reference_document_description",
              label: "Reference Document Description",
            },

            {
              key: "grand_parent_document_title",
              label: "Grand Parent Document Title",
            },
            {
              key: "grand_parent_document_description",
              label: "Grand Parent Document Description",
            },
            {
              key: "parent_document_title",
              label: "Parent Document Title",
            },
            {
              key: "parent_document_description",
              label: "Parent Document Description",
            },
          ]}
        />
        ;
      </div>
<TranslationModal
  open={translationOpen}
  onClose={() => setTranslationOpen(false)}
  loading={translationLoading}
  completed={translationCompleted}
  previewUrl={translationPreviewUrl}
  onGenerate={handleGenerateTranslation}
  onPreview={handlePreviewTranslation}
  onAccept={handleAcceptTranslation}
  onReject={handleRejectTranslation}
/>
<SummaryModal
  open={summaryOpen}
  onClose={() => setSummaryOpen(false)}
  loading={summaryLoading}
  completed={summaryCompleted}
  onGenerate={handleGenerateSummary}
  onAccept={handleAcceptSummary}
  onReject={handleRejectSummary}
  summaryResponse={summaryResponse}

/>


      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setisModalOpen(false)}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  );
};

export default Approval;
